export default __webpack_public_path__ + "static/media/send-plane-fill.2b7e971f.svg";